import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import bluecta from '../../images/arrow-right-blue-cta.svg';
import rightWhitecta from '../../images/arrow-right-white-cta.svg';
import '../../sass/components/flexibleModules/_components.mastheadWithGrid.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";
import rightArrow from '../../images/arrow-right-white.svg';

const MastheadWithGrid = ({ data }) => {
    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 3000,
        slidesToShow: 6,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    if (data.mastheadSectionWithGridLottiefile === 'yes' && typeof document !== "undefined") {
        var scriptOne = document.createElement('script');
        scriptOne.src = 'https://unpkg.com/@lottiefiles/lottie-player@2.0.12/dist/lottie-player.js';
        document.getElementsByTagName('head')[0].appendChild(scriptOne);
    }

    useEffect(() => {
        var scriptOne = document.createElement('script');
        scriptOne.src = '//fast.wistia.com/embed/medias/otc4mpi3wp.jsonp';
        scriptOne.async = 'async';
        document.getElementsByTagName('head')[0].appendChild(scriptOne);
        var scriptTwo = document.createElement('script');
        scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
        scriptTwo.async = 'async';
        document.getElementsByTagName('head')[0].appendChild(scriptTwo);
    }, []);

    const [videoShow, setVideoShow] = useState(false);
    const showVideo = (val) => {
        setVideoShow(val);
    }

    const [muted, setMuted] = useState(false);
    const [played, setPlayed] = useState(true);

    const videotrigger = (val, id) => {
        if (typeof window !== 'undefined') {
            var video = window.Wistia.api(`wistia-${id}-1`);
            if (val === 'unmute') {
                video.unmute();
                setMuted(true);
            }
            else if (val === 'mute') {
                video.mute();
                setMuted(false);
            }
            else if (val === 'play') {
                video.play();
                setPlayed(true);
            }
            else if (val === 'pause') {
                video.pause();
                setPlayed(false);
            }
            else {
                video.time(video.time() - 5);
            }
        }
    }

    return (
        <div className={`cp-flexibleMasthead ${data.mastheadGridThumbImages ? "l--fancyMasthead" : "l--nofancyMasthead"} ${data.overrideClass ? data.overrideClass : "l-nooverride"} ${data.layoutSelection} l-textColor${data.textColor} l-pattern${data.iconPatterns}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            {data.mastheadGridThumbImages &&
                <>
                    <span className="l-absoluteIcon l-absoluteIcon1">
                        <StaticImage src="../../images/hero-section-icon1.svg" alt="pattern" />
                    </span>
                    <span className="l-absoluteIcon l-absoluteIcon2">
                        <StaticImage src="../../images/hero-section-icon2.svg" alt="pattern" />
                    </span>
                    <span className="l-absoluteIcon l-absoluteIcon3">
                        <StaticImage src="../../images/hero-section-icon3.svg" alt="pattern" />
                    </span>
                    <span className="l-absoluteIcon l-absoluteIcon4">
                        <StaticImage src="../../images/hero-section-icon4.svg" alt="pattern" />
                    </span>
                    <span className="l-absoluteIcon l-absoluteIcon5">
                        <StaticImage src="../../images/hero-section-icon5.svg" alt="pattern" />
                    </span>
                </>
            }
            <div className={`cp-flexibleMasthead__inner ${data.mastheadSectionWithGridVideo ? "l-video" : "l-novideo"}`} style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.overrideClass &&
                    <>
                        {data.overrideClass.includes('l-newPatterns') &&
                            <>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon1">
                                    <StaticImage src="../../images/icon-yellow.png" alt="pattern" />
                                </span>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon2">
                                    <StaticImage src="../../images/icon-ultraviolet.png" alt="pattern" />
                                </span>
                                <span className="l-absoluteNewIcon l-absoluteNewIcon3">
                                    <StaticImage src="../../images/icon-green.png" alt="pattern" />
                                </span>
                            </>
                        }
                    </>
                }
                {data.mastheadSectionWithGridHeader &&
                    <h1 dangerouslySetInnerHTML={{ __html: data.mastheadSectionWithGridHeader }} />
                }
                {data.mastheadSectionWithGridTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.mastheadSectionWithGridTeaser }} />
                }
                {data.mastheadSectionWithGridButton &&
                    <div className="l-relativeButton">
                        <a className="l-button" href={data.mastheadSectionWithGridButton.url} target={data.mastheadSectionWithGridButton.target}>
                            <span>{data.mastheadSectionWithGridButton.title}</span>
                            {data.textColor === 'light' || data.textColor === 'l-textColorlight' ?
                                <img src={bluecta} alt="" />
                                :
                                <img src={rightWhitecta} alt="" />
                            }
                        </a>
                        <a className="l-button l-backgroundHover" href={data.mastheadSectionWithGridButton.url} target={data.mastheadSectionWithGridButton.target}>
                            <span>{data.mastheadSectionWithGridButton.title}</span>
                            {data.textColor === 'light' || data.textColor === 'l-textColorlight' ?
                                <img src={bluecta} alt="" />
                                :
                                <img src={rightWhitecta} alt="" />
                            }
                        </a>
                    </div>
                }
                {data.mastheadSectionWithGridVideo &&
                    <div className={`cp-wistiaVideoInline ${videoShow ? "l--active" : "l--active"}`}>
                        <div className={`wistia_embed wistia_async_${data.mastheadSectionWithGridVideo} muted=false autoPlay=false`}>&nbsp;</div>
                        {/* <span className="l--controls">
                            {!muted ?
                                <button onClick={() => videotrigger('unmute', data.mastheadSectionWithGridVideo)}><img src={videoIconMuted} alt="" /></button>
                                :
                                <button onClick={() => videotrigger('mute', data.mastheadSectionWithGridVideo)}><img src={videoIconUnmuted} alt="" /></button>
                            }
                            {played ?
                                <button onClick={() => videotrigger('pause', data.mastheadSectionWithGridVideo)}><img src={videoIconPause} alt="" /></button>
                                :
                                <button onClick={() => videotrigger('play', data.mastheadSectionWithGridVideo)}><img src={videoIconPlay} alt="" /></button>
                            }
                            <button onClick={() => videotrigger('replay', data.mastheadSectionWithGridVideo)}><img src={videoIconRePlay} alt="" /></button>
                        </span> */}
                    </div>
                }
                {data.mastheadSectionWithGridVideo ?
                    ""
                    :
                    <div className="l-relative">
                        {data.mastheadSectionWithGridImage &&
                            <div className="cp-flexibleMasthead__image">
                                <div className="cp-flexibleMasthead__image-inner">
                                    {data.iconPatterns === 'yes' &&
                                        <div className="l-absolute">
                                            <StaticImage className="l-pattern1" src="../../images/masthead-pattern1.svg" alt="pattern circle" />
                                            <StaticImage className="l-pattern2" src="../../images/masthead-pattern2.svg" alt="pattern square" />
                                        </div>
                                    }
                                    {data.mastheadSectionWithGridImageLink ?
                                        <a className="l--trigger" href={data.mastheadSectionWithGridImageLink.url} target={data.mastheadSectionWithGridImageLink.target}>
                                            {data.mastheadSectionWithGridImage &&
                                                <GatsbyImage image={data.mastheadSectionWithGridImage.gatsbyImage} alt={data.mastheadSectionWithGridImage.altText} />
                                            }
                                            <span className="l--trigger__absolute l--flex">
                                                <span>{data.mastheadSectionWithGridImageLink.title}</span>
                                                <img loading="lazy" src={rightArrow} alt="" />
                                            </span>
                                        </a>
                                        :
                                        <>
                                            {data.mastheadSectionWithGridImage &&
                                                <GatsbyImage image={getImage(data.mastheadSectionWithGridImage.gatsbyImage)} alt={data.mastheadSectionWithGridImage.altText} />
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
                {/* {data.mastheadSectionWithGridImage &&
                    <div className="cp-flexibleMasthead__image">
                        <div className="cp-flexibleMasthead__image-inner">
                            {data.iconPatterns === 'yes' &&
                                <div className="l-absolute">
                                    <StaticImage className="l-pattern1" src="../../images/masthead-pattern1.svg" alt="pattern circle" />
                                    <StaticImage className="l-pattern2" src="../../images/masthead-pattern2.svg" alt="pattern square" />
                                </div>
                            }
                            {data.mastheadSectionWithGridImage &&
                                <GatsbyImage loading="eager" image={getImage(data.mastheadSectionWithGridImage.gatsbyImage)} alt={data.mastheadSectionWithGridImage.altText} />
                            }
                        </div>
                    </div>
                } */}
                {data.mastheadGridThumbImages &&
                    <>
                        {data.mastheadGridThumbImages.map((thumbs, index) => (
                            <div className={`cp-flexibleMasthead__image--absolute l--absoute${index}`} key={index}>
                                <GatsbyImage image={getImage(thumbs.gatsbyImage)} alt={thumbs.altText} />
                            </div>
                        ))}
                    </>
                }
                {data.mastheadSectionWithGridLottiefile === 'yes' &&
                    <lottie-player src={data.mastheadSectionWithGridLottiefileLink} background="transparent" speed="1" loop autoplay></lottie-player>
                }
                {data.mastheadGridRepeater &&
                    <div className="cp-flexibleMastheadGrid" style={{ backgroundColor: `${data.mastheadGridRepeaterBackgroundColor}` }} >
                        {data.mastheadGridRepeaterTitle &&
                            <h4>{data.mastheadGridRepeaterTitle}</h4>
                        }
                        <div className={`cp-flexibleMastheadGrid__inner ${data.mastheadGridRepeaterCarouselCheck === 'yes' ? 'l--block l--carousel' : 'l--flex'}`} >
                            {
                                data.mastheadGridRepeaterCarouselCheck === 'yes' ?
                                    <>
                                        {isRendered &&
                                            <Slider {...settings}>
                                                {data.mastheadGridRepeater.map((gridItems, index) => (
                                                    <React.Fragment key={index}>
                                                        {
                                                            gridItems.iconsOrLogos === "logos" ?
                                                                <div className="l-gridLogos" key={index}>
                                                                    {gridItems.logo &&
                                                                        <GatsbyImage image={getImage(gridItems.logo.gatsbyImage)} alt={gridItems.logo.altText} />
                                                                    }
                                                                </div>
                                                                :
                                                                <div className="l-grid" key={index}>
                                                                    {gridItems.icon &&
                                                                        <img src={gridItems.icon.sourceUrl} alt={gridItems.icon.altText} />
                                                                    }
                                                                    {gridItems.title &&
                                                                        <h3>{gridItems.title}</h3>
                                                                    }
                                                                    {gridItems.teaser &&
                                                                        <p>{gridItems.teaser}</p>
                                                                    }
                                                                </div>
                                                        }
                                                    </React.Fragment>
                                                ))}
                                            </Slider>
                                        }
                                    </>
                                    :
                                    <>
                                        {data.mastheadGridRepeater.map((gridItems, index) => (
                                            <React.Fragment key={index}>
                                                {
                                                    gridItems.iconsOrLogos === "logos" ?
                                                        <div className="l-gridLogos" key={index}>
                                                            {gridItems.logo &&
                                                                <GatsbyImage image={getImage(gridItems.logo.gatsbyImage)} alt={gridItems.logo.altText} />
                                                            }
                                                            <h3>{gridItems.title}</h3>
                                                        </div>
                                                        :
                                                        <div className="l-grid" key={index}>
                                                            {gridItems.icon &&
                                                                <img src={gridItems.icon.sourceUrl} alt={gridItems.icon.altText} />
                                                            }
                                                            {gridItems.title &&
                                                                <h3>{gridItems.title}</h3>
                                                            }
                                                            {gridItems.teaser &&
                                                                <p>{gridItems.teaser}</p>
                                                            }
                                                        </div>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </>
                            }
                        </div>
                    </div>
                }
            </div>
        </div >
    );
}

export default MastheadWithGrid;